(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["we-are-size-fit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('we-are-size-fit')) {
    class WeAreSizeFit extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-size-fit-dialog]');
        this.drawerPanel = this.querySelector('[data-size-fit-panel]');
        this.openButton = this.querySelector('[data-size-fit-open]');
        this.closeButton = this.querySelector('[data-size-fit-close]');
        this.tabs = Array.from(this.querySelectorAll('[data-size-fit-tab]'));
        this.tabPanels = Array.from(this.querySelectorAll('[data-size-fit-panel-name]'));

        if (!this.dialog || !this.openButton || !this.closeButton) return;

        this.handleClickBound = this.handleClick.bind(this);
        this.handleKeydownBound = this.handleKeydown.bind(this);
        this.handleCancelBound = this.handleCancel.bind(this);
        this.handleCloseBound = this.handleClose.bind(this);
        this.handleBlockSelectBound = this.handleBlockSelect.bind(this);
        this.handleBlockDeselectBound = this.handleBlockDeselect.bind(this);

        this.addEventListener('click', this.handleClickBound);
        this.addEventListener('keydown', this.handleKeydownBound);
        this.dialog.addEventListener('cancel', this.handleCancelBound);
        this.dialog.addEventListener('close', this.handleCloseBound);
        this.addEventListener('shopify:block:select', this.handleBlockSelectBound);
        this.addEventListener('shopify:block:deselect', this.handleBlockDeselectBound);
      }

      disconnectedCallback() {
        if (!this.dialog) return;

        this.removeEventListener('click', this.handleClickBound);
        this.removeEventListener('keydown', this.handleKeydownBound);
        this.dialog.removeEventListener('cancel', this.handleCancelBound);
        this.dialog.removeEventListener('close', this.handleCloseBound);
        this.removeEventListener('shopify:block:select', this.handleBlockSelectBound);
        this.removeEventListener('shopify:block:deselect', this.handleBlockDeselectBound);
        window.clearTimeout(this.closeTimer);
      }

      handleClick(event) {
        const openControl = event.target.closest('[data-size-fit-open]');
        const closeControl = event.target.closest('[data-size-fit-close]');
        const tab = event.target.closest('[data-size-fit-tab]');

        if (openControl) {
          this.openDrawer(openControl);
          return;
        }

        if (closeControl || event.target === this.dialog) {
          this.closeDrawer();
          return;
        }

        if (tab) this.activateTab(tab, true);
      }

      handleKeydown(event) {
        const currentTab = event.target.closest('[data-size-fit-tab]');

        if (!currentTab || this.tabs.length < 2) return;

        const currentIndex = this.tabs.indexOf(currentTab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        if (nextIndex === currentIndex) return;

        event.preventDefault();
        this.activateTab(this.tabs[nextIndex], true);
      }

      handleCancel(event) {
        event.preventDefault();
        this.closeDrawer();
      }

      handleClose() {
        this.dialog.classList.remove('is-active');

        if (!document.querySelector('.we-are-size-fit__dialog[open]')) {
          document.documentElement.classList.remove('we-are-size-fit-is-open');
        }

        if (this.lastTrigger && document.contains(this.lastTrigger)) {
          this.lastTrigger.focus();
        }
      }

      handleBlockSelect() {
        this.openDrawer(this.openButton);
      }

      handleBlockDeselect() {
        this.closeDrawer();
      }

      openDrawer(trigger) {
        if (this.dialog.open) return;

        this.lastTrigger = trigger;
        this.dialog.showModal();
        document.documentElement.classList.add('we-are-size-fit-is-open');

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            this.dialog.classList.add('is-active');
            this.closeButton.focus();
          });
        });
      }

      closeDrawer() {
        if (!this.dialog.open) return;

        this.dialog.classList.remove('is-active');
        window.clearTimeout(this.closeTimer);
        this.closeTimer = window.setTimeout(() => {
          if (this.dialog.open) this.dialog.close();
        }, 250);
      }

      activateTab(activeTab, moveFocus) {
        const panelName = activeTab.dataset.sizeFitTab;

        this.tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.tabPanels.forEach((panel) => {
          panel.hidden = panel.dataset.sizeFitPanelName !== panelName;
        });

        if (moveFocus) activeTab.focus();
      }
    }

    customElements.define('we-are-size-fit', WeAreSizeFit);
  }
  } catch(e) { console.error(e); }
})();

})();
